import { render, staticRenderFns } from "./WithChat.vue?vue&type=template&id=565c9cd8&scoped=true&"
import script from "./WithChat.vue?vue&type=script&lang=js&"
export * from "./WithChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c9cd8",
  null
  
)

export default component.exports